import React, { useState, useEffect } from 'react';

import { Grid, Typography, TextField, Box } from '@mui/material';

function JobCardFeedback(props) {
  const setFeedback = props.setFeedback;

  // const NotesTitle = props.notesType;
  const [feedbackData, setFeedbackData] = useState(props.feedbackInfo.feedback);

  useEffect(() => {
    let data = props.feedbackInfo;
    setFeedbackData(data.feedback);
  }, [props.feedbackInfo]);

  return (
    <div className='no-print-break'>
      <Grid item xs={12} md={12} style={{ textAlign: 'left' }}>
        <Typography variant='h6' fontWeight='700'>
          Customer Feedback
        </Typography>
      </Grid>

      <Grid
        item
        border={'grey solid 1px'}
        xs={12}
        md={12}
        style={{
          textAlign: 'left',
          borderLeft: 'none',
        }}
      >
        <Box sx={{ minHeight: '100px', border: 'solid #808080 1px' }} />
        {/* <TextField
          multiline
          size='small'
          fullWidth
          value={feedbackData}
          onChange={
            (value) => setFeedback(value.target.value)
            // console.log(value.target.value)
          }
        /> */}
      </Grid>
    </div>
  );
}

export default JobCardFeedback;
